import { getApiBase } from "./api-base";
import { withAuthToken } from "./auth";

/** Absolute URL for API-served media (`/api/media?...`). */
export function resolveMediaUrl(url?: string | null): string {
  if (!url) return "";
  // Local previews (blob:/data:) are not served by the API — never touch them.
  if (url.startsWith("blob:") || url.startsWith("data:")) {
    return url;
  }
  // Absolute API URLs (same-origin) still need the token for the API guard.
  if (url.startsWith("http")) {
    return withAuthToken(url);
  }
  const apiBase = getApiBase();
  return withAuthToken(
    `${apiBase}${url.startsWith("/") ? url : `/${url}`}`,
  );
}

/** Contact / follower photo URL (`/api/media?account=&peer=&contact_avatar=1`). */
export function contactAvatarMediaUrl(
  account?: string | null,
  peer?: string | null,
): string {
  const a = String(account || "").trim();
  const p = String(peer || "")
    .replace(/^@/, "")
    .trim();
  if (!a || !p) return "";
  return resolveMediaUrl(
    `/api/media?account=${encodeURIComponent(a)}` +
      `&peer=${encodeURIComponent(p)}&contact_avatar=1`,
  );
}
